export default __webpack_public_path__ + "assets/lamina-component.0b61b64e.svg";